export default __webpack_public_path__ + "static/media/amazonClaimed.e0bb5900.svg";